"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryNavigation = SecondaryNavigation;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _Link = require("../../elements/link/Link");
var _classnames4 = _interopRequireDefault(require("classnames"));
var _secondaryNavigationModule = _interopRequireDefault(require("./secondary-navigation.module.scss"));
function SecondaryNavigation(_ref) {
  var categories = _ref.categories,
    className = _ref.className,
    icon = _ref.icon;
  return /*#__PURE__*/_react.default.createElement("nav", {
    "data-testid": "nav",
    className: (0, _classnames4.default)(_secondaryNavigationModule.default['secondary-navigation'], className),
    "aria-label": "Sub menu"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: _secondaryNavigationModule.default['secondary-navigation__list']
  }, categories.map(function (_ref2) {
    var id = _ref2.id,
      title = _ref2.title,
      active = _ref2.active,
      url = _ref2.url,
      extra = _ref2.extra,
      onClick = _ref2.onClick,
      className = _ref2.className;
    return /*#__PURE__*/_react.default.createElement("li", {
      "data-testid": "nav-item",
      key: id,
      className: (0, _classnames4.default)(_secondaryNavigationModule.default['secondary-navigation__item'], className, (0, _defineProperty2.default)({}, _secondaryNavigationModule.default['secondary-navigation__item--active'], active))
    }, onClick ? /*#__PURE__*/_react.default.createElement("div", {
      role: "button",
      onClick: onClick,
      className: (0, _classnames4.default)(_secondaryNavigationModule.default['secondary-navigation__link'], (0, _defineProperty2.default)({}, _secondaryNavigationModule.default['secondary-navigation__link--active'], active))
    }, title, extra && /*#__PURE__*/_react.default.createElement("span", {
      className: _secondaryNavigationModule.default['secondary-navigation__extra']
    }, extra)) : /*#__PURE__*/_react.default.createElement(_Link.Link, {
      href: url,
      className: (0, _classnames4.default)(_secondaryNavigationModule.default['secondary-navigation__link'], (0, _defineProperty2.default)({}, _secondaryNavigationModule.default['secondary-navigation__link--active'], active))
    }, title, extra && /*#__PURE__*/_react.default.createElement("span", {
      className: _secondaryNavigationModule.default['secondary-navigation__extra']
    }, extra)));
  })), icon);
}